import { render } from "./ProdutosView.vue?vue&type=template&id=b50f287a&scoped=true"
import script from "./ProdutosView.vue?vue&type=script&lang=js"
export * from "./ProdutosView.vue?vue&type=script&lang=js"

import "./ProdutosView.vue?vue&type=style&index=0&id=b50f287a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b50f287a"]])

export default __exports__